import {call, put, takeLatest} from "redux-saga/effects";
import moment from "moment";
import {apiGetVisits} from "../api";

import setOneDayAgo from "utils/time/setOneDayAgo";
import setOneWeekAgo from "utils/time/setOneWeekAgo";
import setOneMonthAgo from "utils/time/setOneMonthAgo";
import setOneYearAgo from "utils/time/setOneYearAgo";

import getChartTimeLabels from "utils/charts/getChartTimeLabels";

import actions from "../actions";

const {
  GET_YEAR_VISITS_REQUEST,
  GET_MONTH_VISITS_REQUEST,
  GET_WEEK_VISITS_REQUEST,
  GET_DAY_VISITS_REQUEST,
  getYearVisitsFailure,
  getYearVisitsSuccess,
  getMonthVisitsSuccess,
  getMonthVisitsFailure,
  getWeekVisitsSuccess,
  getWeekVisitsFailure,
  getDayVisitsSuccess,
  getDayVisitsFailure,
} = actions;

const formatData = (timeUnit, data) => {
  return data
    .map((item) => item.visits)
    .filter((item) => item.length > 0)
    .flat()
    .sort((a, b) => {
      return Number(b.timestamp) - Number(a.timestamp);
    })
    .map((item) => {
      const date = moment(item.timestamp * 1000);

      let dateFormat;
      switch (timeUnit) {
        case "year":
          dateFormat = "MMM YY";
          break;
        case "month":
          dateFormat = "DD MMM";
          break;
        case "week":
          dateFormat = "DD";
          break;
        case "day":
          dateFormat = "HH";
          break;
      }

      item.formattedDate = date.format(dateFormat);

      return item;
    });
};

const generateChartData = (timeUnit, data, name) => {
  const chartConfig = {
    backgroundColor: "rgba(254, 203, 69, 0.3)",
    borderWidth: 3,
    borderColor: "rgba(254, 203, 69, 1)",
    tension: 0.5,
  };

  if (data) {
    const labels = getChartTimeLabels(timeUnit);

    const hashTable = {};
    labels.forEach((item) => (hashTable[item] = 0));
    data.forEach((item) => {
      if (hashTable.hasOwnProperty(item.formattedDate)) {
        hashTable[item.formattedDate] =
          hashTable[item.formattedDate] + item.number;
      }
    });

    const dataSet = Object.values(hashTable);

    const readyData = {};

    readyData.labels = labels;
    readyData.datasets = [
      {
        label: name,
        data: dataSet,
        ...chartConfig,
        // ...dataSetConfig,
      },
    ];

    return readyData;
  }
};

function* getYearVisitsWorker(action) {
  action.payload.startDate = setOneYearAgo();

  action.payload.timeUnit = "monthly";

  try {
    const apiResult = yield call(apiGetVisits, action.payload);

    const formattedResponse = formatData("year", apiResult.data);
    const readyChartData = yield generateChartData(
      "year",
      formattedResponse,
      "Visits"
    );

    yield put(getYearVisitsSuccess(readyChartData));
  } catch (error) {
    const errorMessage = yield error.message;
    yield put(getYearVisitsFailure(errorMessage));
    console.log("errorMessage");
    console.log(errorMessage);
  }
}

function* getMonthVisitsWorker(action) {

  action.payload.startDate = setOneMonthAgo();

  action.payload.timeUnit = "daily";
  try {
    const apiResult = yield call(apiGetVisits, action.payload);

    const formattedResponse = formatData("month", apiResult.data);
    const readyChartData = yield generateChartData(
      "month",
      formattedResponse,
      "Visits"
    );

    yield put(getMonthVisitsSuccess(readyChartData));
  } catch (error) {
    const errorMessage = yield error.message;
    yield put(getMonthVisitsFailure(errorMessage));
    console.log("errorMessage");
    console.log(errorMessage);
  }
}

function* getWeekVisitsWorker(action) {
  action.payload.startDate = setOneWeekAgo();

  action.payload.timeUnit = "daily";
  try {
    const apiResult = yield call(apiGetVisits, action.payload);

    const formattedResponse = formatData("week", apiResult.data);
    const readyChartData = yield generateChartData(
      "week",
      formattedResponse,
      "Visits"
    );

    yield put(getWeekVisitsSuccess(readyChartData));
  } catch (error) {
    const errorMessage = yield error.message;
    yield put(getWeekVisitsFailure(errorMessage));
    console.log("errorMessage");
    console.log(errorMessage);
  }
}

function* getDayVisitsWorker(action) {
  action.payload.startDate = setOneDayAgo();

  action.payload.timeUnit = "hourly";
  try {
    const apiResult = yield call(apiGetVisits, action.payload);

    const formattedResponse = formatData("day", apiResult.data);
    const readyChartData = yield generateChartData(
      "day",
      formattedResponse,
      "Visits"
    );

    yield put(getDayVisitsSuccess(readyChartData));
  } catch (error) {
    const errorMessage = yield error.message;
    yield put(getDayVisitsFailure(errorMessage));
    console.log("errorMessage");
    console.log(errorMessage);
  }
}

export default function* watcher() {
  yield takeLatest(GET_YEAR_VISITS_REQUEST, getYearVisitsWorker);

  yield takeLatest(GET_MONTH_VISITS_REQUEST, getMonthVisitsWorker);

  yield takeLatest(GET_WEEK_VISITS_REQUEST, getWeekVisitsWorker);

  yield takeLatest(GET_DAY_VISITS_REQUEST, getDayVisitsWorker);
}
